<template>
    <div class="page">
        <box fill>





          <div style="overflow: hidden; padding-bottom: 10px">
            <el-form label-position="right" label-width="80px" :model="printObjs">
              <el-col :lg="5" :xl="5">
                <el-form-item label="外协单号" prop="soCode" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.soCode"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.matCode"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.batchNo"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="扫描接收" class="EL-Form-Item">
                  <el-select v-model="printObjs.scanFlag" placeholder="请选择" clearable="clearable">
                    <el-option label="全部" value="" />
                    <el-option label="是" value="1" />
                    <el-option label="否" value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="22" :xl="9">
              <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;margin-left:10px;float: right;" @click="downLoadFile">导出EXCEL</el-button>
              <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;margin-left:10px;float: right;" @click="submitOutsource">打印标签</el-button>
              <el-button type="primary" class="btn-t-delete" style="margin-top:10px;margin-bottom:10px;margin-left:10px;float: right;" @click="deletePrint()">删除</el-button>
                <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;float: right;" @click="getOutsourcePrintList()">查询</el-button>
              </el-col>
                <!--
              <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;float: right;" @click="pdfPrint()">打印</el-button>
-->

            </el-form>
          </div>
          <h-table :summaryMethod="getSummaries" show-summary :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getOutsourcePrintList"  :data="outsourcePrintList" @selectionChange="selectOutsourcePrint" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
            <el-table-column type="selection" align="center">
            </el-table-column>
            <el-table-column label="通道" prop="whCode" align="center">
            </el-table-column>
            <el-table-column label="物料编号" prop="matCode" align="center">
            </el-table-column>
            <el-table-column label="物料描述" prop="matName" align="center">
            </el-table-column>
            <el-table-column label="数量" prop="boxQuan" palign="center">
            </el-table-column>
            <el-table-column label="批次" prop="batchNo" align="center">
            </el-table-column>
            <el-table-column label="箱号" prop="boxBarcode" align="center">
            </el-table-column>
            <el-table-column label="汇报完成的库位" prop="laCheckCode" align="center">
            </el-table-column>
            <el-table-column label="外协单号" prop="soCode" align="center">
            </el-table-column>
            <el-table-column label="操作人" prop="person" palign="center">
            </el-table-column>
            <el-table-column label="是否扫描接收" prop="scanFlag" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.scanFlag == true"> 是</div>
                <div v-if="scope.row.scanFlag == false">否</div>
              </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime" align="center">
            </el-table-column>
          </h-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogPrintClose" type="info">取 消</el-button>
          </div>






        </box>
    </div>
</template>

<script>
    import moment from "moment";
    import OutsourceLabelReturn from "@/views/printPages/outsource-label-return.vue";
    import vPrint from 'syl-vue-printer'
    export default {
        name: "supplierOutsource",
        components: {
          OutsourceLabelReturn,
          vPrint

        },
        data() {
            return {
                printData: [], //打印数据
                print: false,
                printShow: false,
                prints: false,
                printShows: false,
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                user:localStorage.getItem("user"),
                summarySumNumber:0,
                boxNumber:"",
                soCode:"",
                printTime: moment(new Date).format("yyyy-MM-DD"),
                editNumShow:false,
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                whCodes:"",
                oldMatQuan:"",
                form: {},
              // 标签打印
                labelPrintShow: false,
                labelPrintFlag: false,
                labelPrintData: null,
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
              mainNum:{
                nowNum:"",
              },
				searchInfo: {
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "30,80,90",
                    whCode: localStorage.getItem("whCode") || "",
                    //laCode: "",
                    laCode: localStorage.getItem("empNumber") || "",
                    supplyNumber: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
				},
                printObjs:{
                    matCode:"",
                    batchNo:"",
                    soCode:"",
                    scanFlag:"",
                },

                warehouseList: [],
                mainObj: {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                },
                rules: {
                    soCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    laOutsouceCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    boxBarcode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },

                addOutsourceList: [],

                laCodeList: [],
                checkOutsourceList: [], //多选

                editBoxShow: false,

                downloadLoading: false, //下载中

                detailsDialogShow: false,
                detailsDialogShows:false,
                outsourceLists: [],
                checkListDet: [], //全选

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
                //打印显示
                outsourcePrintList:[],
                checkoutsourcePrintList: [], //多选
            };
        },
        watch: {
            searchInfo: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getOutsource(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.searchInfo.requireDate[0]) {
                            return time.getTime() < new Date(_this.searchInfo.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.searchInfo.requireDate[1]) {
                            return time.getTime() > new Date(_this.searchInfo.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
          //表单验证
          submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                r = true;
              } else {
                r = false;
              }
            });
            return r;
          },

          getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '合计';
                return;
              }
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value)) && column.property == "boxQuan") {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index];
              }
            });

            return sums;
          },

            //查询添加数据
            selOutsourceList() {
                this.addOutsourceList = []
                this.$http
                    .request({
                        url: "/api/outsource/getOutsourceDetail",
                        method: "GET",
                        params: {
                            soCode: this.mainObj.soCode || null,
                            fcCode: localStorage.getItem("fcCode") || null,
                            statusList: "30" || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list != null) {
                                let list = resp.data.list;
                                list.forEach((item) => {
                                    let tabData = {
                                        soId: item.soId,
                                        whCode: item.whCode,
                                        soCode: item.soCode,
                                        laCode: item.laCode,
                                        laOutsouceCode: item.laOutsouceCode,
                                        laCheckCode: item.laCheckCode,
                                        matCode: item.matCode,
                                        matName: item.matName,
                                        matCheckCode: item.matCheckCode,
                                        boxBarcode: item.boxBarcode,
                                        boxQuan: item.boxQuan,
                                        batchNo: item.batchNo
                                    }
                                    this.addOutsourceList.push(tabData)
                                })
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "未找到记录！",
                                });
                            }
                            // console.log(this.addOutsourceList)
                        }
                    })
                    .catch((error) => {});
            },
            deletePrint(){
                 if (this.checkoutsourcePrintList.length == 0) {
                    this.$message({
                        type: "warning",
                        message: "请选择外协汇报记录！",
                    });
                    return
                // }else if(this.checkoutsourcePrintList.length>1){
                //    this.$message({
                //      type: "warning",
                //      message: "只能操作一条！",
                //    });
                //    return
                 }else{
                    var sopIds = "";
                    var isreturn = false;
                    this.checkoutsourcePrintList.forEach((item)=>{
                        if(item.scanFlag == '1'){
                          this.$message({
                            type: "warning",
                            message: "已经接收的不能删除！",
                          });
                          isreturn = true;
                        }
                        sopIds += item.sopId + ","
                    })
                   if(isreturn){
                     return;
                   }
                    this.$confirm("是否删除该外协汇报记录? ", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/outsource/deleteOutsourcePrint",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    sopIds:sopIds,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        type: "success",
                                        message: "删除成功！",
                                    });
                                    this.getOutsourcePrintList();
                                    this.logRemarks = "outsource：删除外协汇报记录成功(修改)";
                                } else {
                                    this.$message({
                                        type: "warning",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "outsource：删除外协汇报记录失败(修改)";
                                }
                            })
                            .catch((error) => {
                                this.loading++;
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },


            //多选
            selectOutsource(val) {
                this.checkOutsourceList = val;
            },




            //打印多选
            selectOutsourcePrint(val) {
                this.checkoutsourcePrintList = val;
            },

            //取消
            dialogPrintClose() {
                this.outsourcePrintList=[];
                this.detailsDialogShows = false;
                this.checkoutsourcePrintList = [];
                this.getOutsource();
                this.printObjs={}
            },



            // 禁选
            checkboxSelect(row, rowIndex) {
                // if (row.soStatus != "30") {
                //     return false; // 禁用
                // } else {
                //     return true; // 不禁用
                // }
                return true;
            },



            //全选
            checkboxDet(val) {
                this.checkListDet = val;
            },
            //取消
            dialogClose() {
                this.detailsDialogShow = false;
                this.outsourceLists = [];
                this.getOutsource();
            },


            //获取打印数据
            getOutsourcePrintList(){
                 this.$http
                    .request({
                        url: "/api/outsource/getOutsourcePrintList",
                        method: "GET",
                        params: {
                            soCode: this.printObjs.soCode || null,
                            matCode: this.printObjs.matCode || null,
                            batchNo: this.printObjs.batchNo || null,
                            scanFlag:this.printObjs.scanFlag,
                            laCheckCode:localStorage.getItem("user"),
                            pageNum:this.pagination.pageNum,
                            pageSize:this.pagination.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                                this.outsourcePrintList = resp.data.list || []
                                this.pagination.total = resp.data.total;
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "未找到记录！",
                                });
                            }
                            this.tablesoCode = ""
                    })
            },



            //清除
            clearOutsource() {
                this.mainObj = {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                }
                this.addOutsourceList = []
            },

            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
				};
				this.searchInfo = {
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "30",
                    whCode: localStorage.getItem("whCode") || "",
                    laCode: "",
                    supplyNumber: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
                };
                this.getOutsource();
            },

            //表格导出
            downLoadFile() {


                this.downloadLoading = true;
                var paramsObj = {
                    soCode: this.printObjs.soCode || null,
                    matCode: this.printObjs.matCode || null,
                    batchNo: this.printObjs.batchNo || null,
                    scanFlag:this.printObjs.scanFlag,
                    laCheckCode:localStorage.getItem("user"),
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/outsource/getOutsourcePrintList',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
          /**
           *提交并且打印标签
           */
          submitOutsource() {

            if(this.checkoutsourcePrintList.length == 0){

              this.$message.warning({
                title: "提示",
                message: "请选择待打印记录",
              });

              return false;
            }

                  var returnData = this.checkoutsourcePrintList;

                  //标签打印
                  returnData.forEach((item) => {
                    var produceTime = moment(item.fifoDate).format("YYYYMMDD");
                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                    // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                    //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                    //     "/" + produceTime + "/" + item.boxHeight + "/";

                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                    var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                        item.matCode + "," + item.boxQuan + "," + item.matSpecs +
                        "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                    if (item.matSpecs == undefined) {
                      item.matSpecs = "";
                    }

                    var person = localStorage.getItem("user");
                    if (person != undefined && person != '') {
                      person = item.consignee;
                    }

                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                    var barcodeData = {
                      boxBarcode: item.boxBarcode,
                      prodCode: item.matCode,
                      prodName: item.matName,
                      batchNo: item.batchNo,
                      count: item.boxQuan,
                      checkPerson: person,
                      date: produceTime,
                      poCode: item.orderCode,
                      matSpecs: item.matSpecs,
                      whCode: item.whCode,
                      qrCode: qrCode,
                      supply: item.verdorCode,
                      produceCode:item.finishProduct,
                      printTime: printTime,
                      isSta: false,
                      printTwo: false,
                      location: item.laCheckCode,
                      boxHeight: "1234",
                      heatBatchNo: item.heatNumber,
                      luhao: item.heatNo,
                      oldBoxbarcode: item.soCode,
                      checkResult: "20",
                      orderNumber:item.opCode,
                      produceDesc:item.finishProductName,
                    }
                    this.$printer.printWMSBarcodeWx(barcodeData);






            })
          },

            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        // if (c.soStatus == '10') {
                        //     c['soStatus'] = '创建'
                        // } else if (c.soStatus == '20') {
                        //     c['soStatus'] = '进行中'
                        // } else if (c.soStatus == '30') {
                        //     c['soStatus'] = '报检完成'
                        // } else if (c.soStatus == '40') {
                        //     c['soStatus'] = '收货完成'
                        // } else if (c.soStatus == '50') {
                        //     c['soStatus'] = '关闭'
                        // }
                        if (c.soStatus == '80') {
                            c['soStatus'] = '待接收'
                        } else if (c.soStatus == '40') {
                            c['soStatus'] = '收货完成'
                        } else if (c.soStatus == '90') {
                          c['soStatus'] = '发货完成'
                        } else if (c.soStatus == '30') {
                          c['soStatus'] = '出库完成'
                        } else if (c.soStatus == '50') {
                            c['soStatus'] = '关闭'
                        }else if (c.soStatus == '70') {
                            c['soStatus'] = '完成'
                        }

                        if (c.scanFlag == true) {
                            c['scanFlag'] = '是'
                        } else if (c.scanFlag == false) {
                            c['scanFlag'] = '否'
                        }
                    })
                    const tHeader = ['通道', '物料编号', '物料描述','数量','批次','箱号','汇报完成库位','外协单号',  '操作人', '是否扫描确认',
                         '更新时间'
                    ]
                    const filterVal = ['whCode','matCode', 'matName', 'boxQuan','batchNo','boxBarcode', 'laCheckCode', 'soCode', 'person',  'scanFlag',
                         'updateTime'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '供应商外协打印数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_outsource：导出供应商外协打印数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },



            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "供应商外协",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },







        },
        activated(){
            /* 获取首页的数据 */
          this.getOutsourcePrintList();
        },
    };
</script>

<style>
.div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}
</style>
